/* @flow */
import idx from 'idx';
import * as React from 'react';
import { graphql } from 'react-apollo';
import DELETE_LTI from 'admin/queries/deleteLTI.gql';
import GET_LTI from 'admin/queries/getLTIForOrganization.gql';
import { getApolloClientSingleton } from 'lib/apollo/client/browser';
import ROTATE_CREDENTIALS from 'admin/queries/rotateLTICredentials.gql';

type Props = {
  data: *,
  children: Function,
  deleteLTI: Function,
  serviceKey: string,
  organizationUUID: string,
  rotateCredentials: Function,
};

class LTIContainer extends React.Component<Props, {}> {
  deleteLTI = () => {
    return this.props
      .deleteLTI({
        variables: {
          input: {
            serviceKey: this.props.serviceKey,
            organizationUUID: this.props.organizationUUID,
          },
        },
      })
      .then(() => {
        getApolloClientSingleton().writeQuery({
          query: GET_LTI,
          data: { LTI: null },
          variables: {
            serviceKey: this.props.serviceKey,
            organizationUUID: this.props.organizationUUID,
          },
        });
      });
  };

  rotateCredentials = () => {
    return this.props
      .rotateCredentials({
        variables: {
          input: {
            serviceKey: this.props.serviceKey,
            organizationUUID: this.props.organizationUUID,
          },
        },
      })
      .then(r => {
        getApolloClientSingleton().writeQuery({
          query: GET_LTI,
          data: { LTI: r.data.rotateLTICredentials.integration },
          variables: {
            serviceKey: this.props.serviceKey,
            organizationUUID: this.props.organizationUUID,
          },
        });

        return {
          clientId: idx(r, _ => _.data.rotateLTICredentials.integration.config.clientId),
          clientSecret: idx(r, _ => _.data.rotateLTICredentials.integration.config.clientSecret),
        };
      });
  };

  getLTI() {
    return idx(this.props, _ => _.data.LTI);
  }

  render() {
    return this.props.children({
      lti: this.getLTI(),
      deleteLTI: this.deleteLTI,
      loading: this.props.data.loading,
      rotateCredentials: this.rotateCredentials,
    });
  }
}

const withDelete = graphql(DELETE_LTI, { name: 'deleteLTI' });
const withRotate = graphql(ROTATE_CREDENTIALS, { name: 'rotateCredentials' });

const withLTI = graphql(GET_LTI, {
  options: ({ organizationUUID, serviceKey }) => ({
    variables: { organizationUUID, serviceKey },
  }),
});

export default withDelete(withRotate(withLTI(LTIContainer)));
